// extracted by mini-css-extract-plugin
export default {"root_scroller":"PX","flex_container":"QX","container":"RX","scroller":"SX","indicator":"TX","scrollButtons":"UX","selected":"VX","root_tab":"WX","root_tab_scrollable":"XX","root_scroller_mob":"YX","scroller_mob":"ZX","indicator_mob":"aY","selected_mob":"bY","root_tab_mob":"cY","root_tab_mob_scrollable":"eY"};
    if(module.hot) {
      // 1714442371287
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  